/* eslint-disable react-hooks/exhaustive-deps */
import { Typography, withStyles, withTheme } from '@material-ui/core';
import { FilteringState, IntegratedFiltering } from '@devexpress/dx-react-grid';
import { Grid, Table, TableFilterRow, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { IntegratedSorting, SortingState } from '@devexpress/dx-react-grid';
import { compose } from 'recompose';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { formatDateGeneric } from 'utilities/common';
import { formatMoney } from 'utilities/currencyFormatter';
import Log from 'utilities/log';
import Spinner from 'modules/common/spinner.component';

const styles = theme => {
  const intakeRecordBorder = `1px solid ${theme.palette.grey[500]}`;
  return {
    table: { borderSpacing: theme.spacing(0, 2) },
    tableHead: { height: 32 },
    cell: {
      borderTop: intakeRecordBorder,
      borderBottom: intakeRecordBorder,
      borderLeft: 0,
      borderRight: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderLeft: intakeRecordBorder
      },
      '&:last-child': {
        borderTopRightRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        borderRight: intakeRecordBorder
      }
    },
    row: { backgroundColor: theme.palette.common.white },
    noDataCell: { paddingBottom: theme.spacing(12), paddingTop: theme.spacing(12), textAlign: 'center' }
  };
};

const FILTER_DISABLED_COLUMNS = ['organization'];

class VouchersGrid extends PureComponent {
  static defaultProps = { isLoading: false };

  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { name: 'voucherId', title: 'Voucher Num', getCellValue: r => r.voucherId },
        { name: 'clientName', title: 'Client', getCellValue: r => r.clientName },
        { name: 'expenseAnalystName', title: 'Expense Analyst', getCellValue: r => r.expenseAnalystName },
        { name: 'payTo', title: 'Pay To', getCellValue: r => r.payTo },
        { name: 'payToName', title: 'Pay To Name', getCellValue: r => r.payToName },
        { name: 'IsRp', title: 'RP Voucher', getCellValue: r => (r.isRecurringPayableVoucher ? 'Yes' : 'No') },
        { name: 'status', title: 'Status', getCellValue: r => <Typography>{r.status}</Typography> },
        {
          name: 'amount',
          title: 'Amount',
          getCellValue: r => <Typography>{r.amount == null ? '' : formatMoney(r.amount)}</Typography>
        },
        { name: 'description', title: 'Description', getCellValue: r => r.description || '' },
        { name: 'invoiceDate', title: 'Invoice Date', getCellValue: r => formatDateGeneric(r.invoiceDate) },
        { name: 'currency', title: 'Currency', getCellValue: r => <Typography>{r.currencyName}</Typography> },
      ],
      filters: [],
      sorting: [{ columnName: 'invoiceDate', direction: 'desc' }],
      integratedFilteringColumnExtensions: [
        {
          columnName: 'IsRp',
          predicate: (value, filter) => (!filter?.value ? true : value === filter.value)
        }
      ],
      tableColumnExtensions: []
    };
    this.changeSorting = sorting => this.setState({ sorting });
  }

  changeFilters = filters => this.setState({ filters });

  filterCell = props =>
    props.column.title && !FILTER_DISABLED_COLUMNS.includes(props.column.name) ? <TableFilterRow.Cell {...props} /> : null;

  headerCell = props => (props.column.title ? <TableHeaderRow.Cell {...props} /> : null);

  headerRowComponent = props => <TableHeaderRow.Row className={this.props.classes.tableHead} {...props} />;

  rowComponent = props => <Table.Row className={this.props.classes.row} {...props} />;

  cellComponent = props => {
    const voucherId = props.row.voucherId;
    const className = classNames(this.props.classes.cell, 'handles-click');
    return <Table.Cell onClick={() => this.props.history.push(`/vouchers/${voucherId}`)} className={className} {...props} />;
  };

  tableComponent = props => <Table.Table className={this.props.classes.table} {...props} />;

  noDataCellComponent = props => {
    const content = this.props.isLoading ? <Spinner logo /> : 'No Records were returned.  Check the filters above.';
    const { getMessage, ...rest } = props;
    return (
      <Table.Cell {...rest} className={this.props.classes.noDataCell}>
        <Typography>{content}</Typography>
      </Table.Cell>
    );
  };

  render() {
    Log.trace('RENDER', 'vouchersGrid');
    const { vouchers } = this.props;
    const { columns, filters, tableColumnExtensions, integratedFilteringColumnExtensions, sorting } = this.state;

    return (
      <Grid rows={vouchers} columns={columns}>
        <SortingState sorting={sorting} onSortingChange={this.changeSorting} />
        <FilteringState filters={filters} onFiltersChange={this.changeFilters} />
        <IntegratedFiltering columnExtensions={integratedFilteringColumnExtensions} />
        <IntegratedSorting />
        <Table
          columnExtensions={tableColumnExtensions}
          rowComponent={this.rowComponent}
          tableComponent={this.tableComponent}
          cellComponent={this.cellComponent}
          noDataCellComponent={this.noDataCellComponent}
        />
        <TableHeaderRow rowComponent={this.headerRowComponent} cellComponent={this.headerCell} showSortingControls />
        <TableFilterRow cellComponent={this.filterCell} />
      </Grid>
    );
  }
}

export default compose(withStyles(styles), withTheme)(VouchersGrid);
